import {get, post} from '../interceptor'

let preUrl = '/energyAnalyse';

export default {
  getCurveByType (params) { return post(preUrl, '/getCurveByType', params) },
  getCurveByDatas (params) { return post(preUrl, '/getCurveByDatas', params) },
  getEnergyCurveByType (params) { return post(preUrl, '/getEnergyCurveByType', params) },
  getEnergyCompare (params) { return post(preUrl, '/getEnergyCompare', params) },
  getMaxPowCurve (params) { return post(preUrl, '/getMaxPowCurve', params) },
  getLossCurve (params) { return post(preUrl, '/getLossCurve', params) },
  getTransferDemand (params) { return post(preUrl, '/getTransferDemand', params) },
  getProtectCurve(params) { return post(preUrl, "/getProtectCurve", params) },
  getDemandAnalyse(params) { return post(preUrl, "/getDemandAnalyse", params) }
}



// WEBPACK FOOTER //
// ./src/api/energy/energyAnalyse.js